// extracted by mini-css-extract-plugin
module.exports = {"backImg":"AemPayloadError_backImg__NYJkL","mainContainer":"AemPayloadError_mainContainer__x7UaY","header":"AemPayloadError_header__cWmyT"};